import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * PasswordInput — a password field with a reveal/hide toggle (v0.245.0).
 *
 * The suite sign-in's field (InSpec src/components/PasswordInput.jsx, the same in Stageit,
 * Program and Workflow): an eye / eye-off button over a native <input> flips
 * its type between 'password' and 'text'. Hidden by default. The toggle is
 * type="button", so it never submits the form, and its label follows its state.
 * Every other input prop (value, onChange, placeholder, autoComplete, disabled,
 * required…) is passed through untouched.
 */
export default function PasswordInput({ className, style, buttonStyle, ...inputProps }) {
  const [shown, setShown] = useState(false);
  const Icon = shown ? EyeOff : Eye;

  return (
    <div style={{ position: 'relative', display: 'block' }}>
      <input
        {...inputProps}
        type={shown ? 'text' : 'password'}
        className={className}
        // Room on the right for the eye, so long text never slides under it.
        style={{ ...style, paddingRight: 42 }}
      />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? 'Hide password' : 'Show password'}
        title={shown ? 'Hide password' : 'Show password'}
        tabIndex={-1}
        style={{
          position: 'absolute',
          top: '50%',
          right: 8,
          transform: 'translateY(-50%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 28,
          height: 28,
          padding: 0,
          border: 'none',
          background: 'transparent',
          color: 'var(--text-500)',
          cursor: 'pointer',
          borderRadius: 6,
          ...(buttonStyle || {}),
        }}
      >
        <Icon size={17} strokeWidth={2} aria-hidden="true" />
      </button>
    </div>
  );
}
